import { render, staticRenderFns } from "./reportTemplate.vue?vue&type=template&id=4c3e2f1d&scoped=true"
import script from "./reportTemplate.vue?vue&type=script&lang=js"
export * from "./reportTemplate.vue?vue&type=script&lang=js"
import style0 from "./reportTemplate.vue?vue&type=style&index=0&id=4c3e2f1d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c3e2f1d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c3e2f1d')) {
      api.createRecord('4c3e2f1d', component.options)
    } else {
      api.reload('4c3e2f1d', component.options)
    }
    module.hot.accept("./reportTemplate.vue?vue&type=template&id=4c3e2f1d&scoped=true", function () {
      api.rerender('4c3e2f1d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/senate/reportTemplate.vue"
export default component.exports